export enum MerchantStatus {
  PENDING = "Active",
  ERROR = "ERROR",
  COMPLETED = "COMPLETED",
}

export interface MerchantListItem {
  id: string;
  name: string;
  email: string;
  isActive: boolean;
  subscription: string;
  isProcessing: boolean;
  logo?: string;
}
